export default __webpack_public_path__ + "static/sticky-logo-text-28049a1539b50bcab090615cd2f1b069.svg";